module.exports = __webpack_public_path__ + "static/media/user_profile.5896d3f9.png";